export const KEY_CODES = {
	SPACE_BAR: 32,
	CARRIAGE_RETURN: 13,
	LEFT_ARROW: 37,
	UP_ARROW: 38,
	RIGHT_ARROW: 39,
	DOWN_ARROW: 40,
	ESCAPE: 27,
	TAB: 9,
	HOME: 36,
	END: 35
};
